import { render } from "./RestoreBackground.vue?vue&type=template&id=2b4b83cb"
import script from "./RestoreBackground.vue?vue&type=script&lang=js"
export * from "./RestoreBackground.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__